<template>
  <form-group class="ma-0 pa-0">
    <v-row>
      <v-col cols="6">
        <client-access-chip
          v-model="getAccess"
          :loading="isLoading"
        />
      </v-col>
      <v-col cols="6">
        <client-access-actions
          :loading="isLoading"
          @success="success($event)"
        />
      </v-col>
    </v-row>
    <v-row class="mt-6">
      <v-col cols="6">
        <client-register-chip
          v-model="getRegister"
          :loading="isLoading"
        />
      </v-col>
      <v-col cols="6">
        <client-register-actions
          :loading="isLoading"
          @success="success($event)"
        />
      </v-col>
    </v-row>
  </form-group>
</template>

<script>
import ClientAccessChip from 'Modules/contacard/analysisTable/components/chips/ClientAccessChip.vue';
import ClientAccessActions from 'Modules/contacard/analysisTable/components/buttons/ClientAccessActions.vue';
import ClientRegisterChip from 'Modules/contacard/analysisTable/components/chips/ClientRegisterChip.vue';
import ClientRegisterActions from 'Modules/contacard/analysisTable/components/buttons/ClientRegisterActions.vue';
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';

export default {
  name: 'AnalysisTableActions',
  components: {
    ClientAccessChip,
    ClientAccessActions,
    ClientRegisterChip,
    ClientRegisterActions,
    FormGroup,
  },
  props: {
    loading: {
      type: Boolean,
    },
  },
  computed: {
    isLoading() {
      return this.loading;
    },
    getRegister() {
      return this.client.situacaoCadastral;
    },
    getAccess() {
      return this.client.situacaoAcesso;
    },
    client() {
      return this.analysisTable.client;
    },
    disabledApprove() {
      return this.getRegister !== 'EM_ANALISE'
      && this.getRegister !== 'PENDENTE';
    },
  },
  methods: {
    success(ev) {
      this.$emit('success', ev);
    },
  },
  inject: {
    analysisTable: {
      default() {
        return {
          client: {
            situacaoCadastral: '',
          },
        };
      },
    },
  },
};
</script>
